import { c as _c } from "react/compiler-runtime";
import { Box, BoxProps } from "@chakra-ui/react";
export interface FilterContainerProps extends BoxProps {
  maxWidth?: string;
}
export const FilterContainer = t0 => {
  const $ = _c(8);
  let children;
  let maxWidth;
  let rest;
  if ($[0] !== t0) {
    ({
      maxWidth,
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = maxWidth;
    $[3] = rest;
  } else {
    children = $[1];
    maxWidth = $[2];
    rest = $[3];
  }
  let t1;
  if ($[4] !== children || $[5] !== maxWidth || $[6] !== rest) {
    t1 = <Box bg="cardBg" borderRadius="card" boxShadow="elevated" px="8" py="10" maxWidth={maxWidth} width="90%" {...rest}>{children}</Box>;
    $[4] = children;
    $[5] = maxWidth;
    $[6] = rest;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};